module.exports = __webpack_public_path__ + "static/media/marketing1.ba112fc0.png";